




















































































































































import { Component, Prop } from 'vue-property-decorator';
import Modal from './Modal.vue';
import CommonVue from '../models/commonVue';
import ApiList from '@/api/list';
import Dimmer from '@/components/Dimmer.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import { VueGoodTable } from 'vue-good-table';
import { isEmpty, isNil } from 'lodash';
import Lesson from '@/api/lesson';
import Exercise from '@/api/exercise';
import { BusEvent } from '@/models/bus';
import { convertExerciseToSentence } from '@/util/content-check/convert-lesson-to-sentence';
import { checkExercise } from '@/util/content-check/content-check';
import { ISentenceCheck } from '@/util/content-check/common';
import ContentCheckResult from '@/components/ContentCheckResult.vue';

@Component({
  components: {
    modal: Modal,
    'drop-down-entity': DropDownEntity,
    'data-table': VueGoodTable,
    dimmer: Dimmer,
    'content-check-result': ContentCheckResult
  }
})
export default class ContentCheck extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  public rows: ISentenceCheck[] = [];
  public columns = [
    {
      label: 'Lesson',
      field: 'lessonId',
      type: 'string'
    },
    {
      label: 'Exercise',
      field: 'exerciseId',
      type: 'string'
    },
    {
      label: 'Game',
      field: 'gameType',
      type: 'string'
    },
    {
      label: 'Content Check',
      field: 'contentCheck',
      type: 'string'
    },
    {
      label: 'Audio Check',
      field: 'audio',
      type: 'string'
    },
    {
      label: 'Save Lesson',
      field: 'processing',
      type: 'string'
    }
  ];

  public lessonList: ApiList<Lesson> = null;
  public exerciseList: ApiList<Lesson> = null;
  public isCheckButtonDisabled: boolean = true;
  public showModal: boolean = false;
  public contentData = null;

  public async load() {
    if (this.moduleId) {
      try {
        this.lessonList = await Lesson.getLessonsOfModule(this.moduleId);
        await this.loadExercises();
        this.isCheckButtonDisabled = false;
      } catch (e) {
        console.log(e);
        this.$bus.$emit(BusEvent.ERROR, 'Could not load lessons', e);
        this.error = true;
      }
    }
  }

  public async loadExercises() {
    const lessons = this.lessonList.results;

    for (const lesson of lessons) {
      const exercises = await Exercise.getExercisesOfLesson(lesson.id, false);

      exercises.results.forEach((item) => {
        const sentence = convertExerciseToSentence(item);

        if (isNil(sentence)) return;
        this.rows.push(sentence);
      });
    }
  }

  public async contentCheck() {
    if (isEmpty(this.rows)) {
      return;
    }

    for (const exercise of this.rows) {
      await checkExercise(exercise);
    }
  }

  public showError(item: ISentenceCheck) {
    this.showModal = true;
    this.contentData = item;
    console.log('contentData', item);
  }

  public onClose(item: ISentenceCheck) {
    this.showModal = false;
    this.contentData = null;
  }
}
